// extracted by mini-css-extract-plugin
export default {"page_component":"Page_page_component__brYWt","page_name":"Page_page_name__plNb0","page_content":"Page_page_content__EJq6l","image":"Page_image__t-jZv"};